import { registerPlugin } from '@capacitor/core';

/**
 * Native bridge for the app-local `WebAuth` Capacitor plugin (iOS), which performs
 * OAuth/OIDC sign-in through `ASWebAuthenticationSession`.
 *
 * This presents an in-app secure browser sheet (no switch to Safari) and returns the
 * provider's callback URL directly to the app without the "open another application"
 * confirmation prompt that a custom-scheme redirect from an external browser triggers.
 */
export interface WebAuthPlugin {
  start(options: { url: string; callbackScheme: string }): Promise<{ callbackUrl: string }>;
}

const WebAuth = registerPlugin<WebAuthPlugin>('WebAuth');

/**
 * Open the native web authentication session for the given authorize URL and resolve with
 * the full callback URL (e.g. `renewmyday://auth/callback?code=...&state=...`).
 *
 * @throws when the user cancels (`USER_CANCELLED`) or the session fails.
 */
export const startNativeWebAuth = async (
  url: string,
  callbackScheme: string
): Promise<string> => {
  const { callbackUrl } = await WebAuth.start({ url, callbackScheme });
  return callbackUrl;
};
